import { render, staticRenderFns } from "./BaseResourceAutoComplete.vue?vue&type=template&id=4c29a26a&"
import script from "./BaseResourceAutoComplete.vue?vue&type=script&lang=js&"
export * from "./BaseResourceAutoComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c29a26a')) {
      api.createRecord('4c29a26a', component.options)
    } else {
      api.reload('4c29a26a', component.options)
    }
    module.hot.accept("./BaseResourceAutoComplete.vue?vue&type=template&id=4c29a26a&", function () {
      api.rerender('4c29a26a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/global/BaseResourceAutoComplete.vue"
export default component.exports